export default __webpack_public_path__ + "static/media/pic1.6497cde5.jpg";